import apiClient, { extractData } from "./client";

/**
 * Send a message to the read-only HR assistant.
 * `history` is the prior turns of the current conversation only
 * (role: "user" | "model"), capped client-side to keep payloads small.
 */
export async function sendAssistantMessage(message, history = []) {
  const response = await apiClient.post("/assistant/chat", {
    message,
    history,
  });
  return extractData(response);
}
